import NextLink from "next/link";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import packageJson from "../../../package.json";
import FooterContent from "./FooterContent";
import {
  ArrowIconStyled,
  BlankContainer,
  CloseButton,
  CloseButtonContainer,
  CloseIconStyled,
  CollapseFooterContainer,
  CopyRightContainer,
  CopyrightContainerMiddle,
  CopyrightText,
  DrawerStyled,
  LinkTextNoMargin,
  MoreButtonContainer,
  VerticalSeparator,
} from "./styles";

export default function SharedCollapsibleFooter() {
  let year = new Date().getFullYear();
  const [hasMounted, setHasMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  // Passing tracking UTM params from v3 employer landing page to v2 employer sign up page
  useEffect(() => {
    setHasMounted(true);
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      {hasMounted === true ? (
        screen.width < 768 ? (
          <FooterContent />
        ) : (
          // Reserve space in the document for the fixed footer.
          <div style={{ height: "60px", flexShrink: 0 }}>
            <BlankContainer>
              <CollapseFooterContainer>
                <CopyRightContainer>
                  <CopyrightText>
                    {`v${packageJson.version} `}
                    {t("footer.copyright", { year })}
                  </CopyrightText>
                </CopyRightContainer>

                <CopyrightContainerMiddle>
                  <NextLink href="/community-guidelines">
                    <LinkTextNoMargin id={"footer-community-guidelines-button"}>
                      {t("footer.community_guidelines")}
                    </LinkTextNoMargin>
                  </NextLink>
                  <VerticalSeparator></VerticalSeparator>
                  <NextLink href="/privacy-policy">
                    <LinkTextNoMargin id={"footer-privacy-policy-button"}>
                      {t("footer.privacy_policy")}
                    </LinkTextNoMargin>
                  </NextLink>
                  <VerticalSeparator></VerticalSeparator>
                  <NextLink href="/terms-and-conditions">
                    <LinkTextNoMargin id={"footer-terms-and-conditions-button"}>
                      {t("footer.terms_and_conditions")}
                    </LinkTextNoMargin>
                  </NextLink>
                  <VerticalSeparator></VerticalSeparator>
                  <NextLink href="/sitemap">
                    <LinkTextNoMargin id={"footer-sitemap-button"}>
                      {t("footer.site_map")}
                    </LinkTextNoMargin>
                  </NextLink>
                  <VerticalSeparator></VerticalSeparator>
                  <MoreButtonContainer>
                    <LinkTextNoMargin onClick={handleClickOpen}>
                      {t("footer.more")}
                      <ArrowIconStyled />
                    </LinkTextNoMargin>
                  </MoreButtonContainer>
                </CopyrightContainerMiddle>
              </CollapseFooterContainer>
            </BlankContainer>
          </div>
        )
      ) : null}

      <DrawerStyled open={open} onClose={handleClose} anchor="bottom">
        <CloseButtonContainer onClick={handleClose}>
          <CloseButton endIcon={<CloseIconStyled />}>
            {t("footer.close")}
          </CloseButton>
        </CloseButtonContainer>
        <FooterContent />
      </DrawerStyled>
    </Fragment>
  );
}
